// extracted by mini-css-extract-plugin
export default {"guidance-content":"GuidanceContent_guidance-content__Aerut","input-node":"GuidanceContent_input-node__pc+fD","hight-light-text":"GuidanceContent_hight-light-text__EdM+a"};